import { Collapse } from 'antd';
import { ReactNode, useState } from 'react';

const { Panel } = Collapse;

export interface CollapseItemType {
    title: string;
    body: string | ReactNode;
    content?: string[];
    footer?: string;
}

const CollapseItem: React.FC<{
    item: CollapseItemType;
    index: number;
    transparent?: boolean;
}> = ({ item, index, transparent }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { title, body, content, footer } = item;
    return (
        <Collapse
            expandIcon={() => (
                <div className="absolute top-12 right-16 h-24 flex items-center">
                    {isOpen ? (
                        <svg
                            className="w-13 h-13 fill-darwin-neutral-900"
                            viewBox="0 0 10 3"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M9.875 1.5C9.875 1.92188 9.52344 2.25 9.125 2.25H0.875C0.453125 2.25 0.125 1.92188 0.125 1.5C0.125 1.10156 0.453125 0.75 0.875 0.75H9.125C9.52344 0.75 9.875 1.10156 9.875 1.5Z" />
                        </svg>
                    ) : (
                        <svg
                            className="w-13 h-13 fill-darwin-neutral-900"
                            viewBox="0 0 10 11"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M5.75 1.375V4.75H9.125C9.52344 4.75 9.875 5.10156 9.875 5.5C9.875 5.92188 9.52344 6.25 9.125 6.25H5.75V9.625C5.75 10.0469 5.39844 10.375 5 10.375C4.57812 10.375 4.25 10.0469 4.25 9.625V6.25H0.875C0.453125 6.25 0.125 5.92188 0.125 5.5C0.125 5.10156 0.453125 4.75 0.875 4.75H4.25V1.375C4.25 0.976562 4.57812 0.625 5 0.625C5.39844 0.625 5.75 0.976562 5.75 1.375Z" />
                        </svg>
                    )}
                </div>
            )}
            onChange={() => setIsOpen(!isOpen)}
            ghost={transparent ?? false}
        >
            <Panel header={<div className="font-700 mr-30">{title}</div>} key={index}>
                <div className="space-y-10">
                    <p>{body}</p>

                    {content && (
                        <div className="space-y-6">
                            {content.map((i, index) => (
                                <p key={index} className="flex items-start space-x-8">
                                    <span>{index + 1}.</span>
                                    <span>{i}</span>
                                </p>
                            ))}
                        </div>
                    )}

                    {footer && <p className="font-700">{footer}</p>}
                </div>
            </Panel>
        </Collapse>
    );
};

export default CollapseItem;
